import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberFormatter',
    standalone: false
})
export class NumberFormatterPipe implements PipeTransform {
  transform(value: number): string {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1000) {
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    }
    return value.toString();
  }
}
